import React from "react";
import { SVGProps } from "../svgData";

export default ({ defaultColor, selectedColor, isSelected }: SVGProps) => {
  const color = isSelected ? selectedColor : defaultColor;

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="menu">
        <path
          id="Vector"
          d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
